module.exports = __webpack_public_path__ + "static/media/empathy2.37950b88.jpg";